import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Session navigateur : cookie HttpOnly uniquement (aucun JWT en localStorage ni en URL).
api.interceptors.request.use((config) => {
  return config;
});

// 401 backend (ex. "Session expiree" / JWT expiré au-delà de la durée absolue) :
// on signale une déconnexion propre. SessionGuard décide d'agir seulement si un
// utilisateur est connecté (évite toute boucle sur la page de login).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      window.dispatchEvent(new CustomEvent("auth:unauthorized"));
    }
    return Promise.reject(error);
  }
);

export default api;
